import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import TableSortLabel from '@mui/material/TableSortLabel';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import PropTypes from 'prop-types';
import React from 'react';
import { cells_config } from './table_configuration';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    searchField: {
        width: '100%',
        '& .MuiInputBase-root': {
            height: '32px',
            fontSize: '0.875rem',
        },
        '& .MuiInputBase-input': {
            padding: '4px 8px',
        },
    },
    selectField: {
        width: '100%',
        '& .MuiSelect-select': {
            height: '32px',
            fontSize: '0.875rem',
            padding: '4px 8px',
        },
    },
}));

const headCells = cells_config;

function CohortTableHead(props) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, searchFilters, onSearchChange } = props;
    const localClasses = useStyles();
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    const renderFilterField = (headCell) => {
        if (headCell.id === 'affectedStatus') {
            return (
                <FormControl size="small" fullWidth>
                    <Select
                        value={searchFilters[headCell.id] || ''}
                        onChange={(e) => onSearchChange(headCell.id, e.target.value)}
                        displayEmpty
                        className={localClasses.selectField}
                    >
                        <MenuItem value="">All</MenuItem>
                        <MenuItem value="Affected">Affected</MenuItem>
                        <MenuItem value="Unaffected">Unaffected</MenuItem>
                        <MenuItem value="NA">NA</MenuItem>
                    </Select>
                </FormControl>
            );
        }
        
        if (headCell.id === 'solved') {
            return (
                <FormControl size="small" fullWidth>
                    <Select
                        value={searchFilters[headCell.id] || ''}
                        onChange={(e) => onSearchChange(headCell.id, e.target.value)}
                        displayEmpty
                        className={localClasses.selectField}
                    >
                        <MenuItem value="">All</MenuItem>
                        <MenuItem value="Solved">Solved</MenuItem>
                        <MenuItem value="Unsolved">Unsolved</MenuItem>
                        <MenuItem value="NA">NA</MenuItem>
                    </Select>
                </FormControl>
            );
        }

        const numericFilterColumns = ['n_snv', 'n_cnv'];
        const isNumericGte = numericFilterColumns.includes(headCell.id);

        return (
            <TextField
                size="small"
                type={isNumericGte ? "number" : "text"}
                placeholder={isNumericGte ? `Equal or bigger` : `Search ${headCell.label}`}
                value={searchFilters[headCell.id] || ''}
                onChange={(e) => onSearchChange(headCell.id, e.target.value)}
                className={localClasses.searchField}
                variant="outlined"
                inputProps={isNumericGte ? { min: 0 } : undefined}
            />
        );
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell />
                {/* <TableCell padding="checkbox">
                    <Checkbox
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{ 'aria-label': 'select all desserts' }}
                    />
                </TableCell>*/}
                {headCells.map((headCell) => (
                    <TableCell
                        style={{color: "#3182bd", fontWeight: "bold"}}
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}>
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
            <TableRow>
                <TableCell />
                {headCells.map((headCell) => (
                    <TableCell 
                        key={`search-${headCell.id}`}
                        align="left"
                        padding="none"
                        style={{ padding: '4px' }}
                    >
                        {renderFilterField(headCell)}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

CohortTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    searchFilters: PropTypes.object.isRequired,
    onSearchChange: PropTypes.func.isRequired,
};

export default CohortTableHead;
